namespace $ {

	export class $shm_hitalama_map_widget_entity_viewport_frame extends $giper_baza_entity.with({

		Ratio: $giper_baza_atom_real,

	}) {

		@ $mol_mem
		ratio( next?: number ) {
			return this.Ratio(next)?.val(next) ?? 0
		}

	}

}
